import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=75bc4fe1&scoped=true&lang=pug"
import script from "./Data.vue?vue&type=script&lang=ts"
export * from "./Data.vue?vue&type=script&lang=ts"
import style0 from "./Data.vue?vue&type=style&index=0&id=75bc4fe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bc4fe1",
  null
  
)

export default component.exports